import { call, put, takeLatest, all } from 'redux-saga/effects';
import {
  PRODUCT_CLASS_LIST_ALL,
  PRODUCT_CLASS_VIEW,
  PRODUCT_CLASS_SEARCH
} from '../actions/productClass/action_types';
import * as apiErrorActions from 'redux/actions/apiError';
import * as productClassService from '../services/productClass';
import * as productClassActions from 'redux/actions/productClass';
import * as listActions from 'redux/actions/list';

function* findAll() {
  yield takeLatest(PRODUCT_CLASS_LIST_ALL, function*(action) {
    try {
      const classes = yield call(productClassService.findAll);
      yield put(productClassActions.foundAll(classes));
    } catch (err) {
      yield apiErrorActions.handle(err);
    }
  });
}

function* findById() {
  yield takeLatest(PRODUCT_CLASS_VIEW, function*(action) {
    try {
      const productClass = yield call(productClassService.findById, action.payload);
      yield put(productClassActions.foundById(productClass));
    } catch (err) {
      yield apiErrorActions.handle(err);
    }
  });
}

function* searchClasses() {
  yield takeLatest(PRODUCT_CLASS_SEARCH, function*(action) {
    try {
      const result = yield call(productClassService.search, action.payload);
      yield put(listActions.listLoaded(result));
    } catch (err) {
      yield apiErrorActions.handle(err);
    }
  });
}

export default function* productClassSagas() {
  yield all([findAll(), findById(), searchClasses()]);
}
